import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "core/hooks/useTranslation";

import { Form, Col, Row, Button } from 'antd';

import Select from 'components/common/select';
import Input from 'components/common/input';

import autoSuggestionType from 'types/autoSuggestion/autoSuggestion.type';

const FIELD_NAMES = {
    NAME: "name",
    TRAFFIC_SOURCES: "trafficSources"
}

const MediaSaveForm = ({
    formInstance,
    formInitialValues,
    trafficSources,
    onValuesChange
}) => {
    const { t } = useTranslation();

    return (
        <Form
            className="rt--form"
            form={formInstance}
            colon={false}
            requiredMark={false}
            layout="vertical"
            initialValues={formInitialValues}
            onValuesChange={onValuesChange}
        >
            <Row gutter={[16, 0]}>
                <Col span={24}>
                    <Form.Item
                        name={FIELD_NAMES.NAME}
                        label={`${t('backoffice.campaigns.name')} *`}
                        className='rt--general-form-item'
                        data-placeholder={`${t('backoffice.common.enter')} ${t('backoffice.campaigns.name')}`}
                        rules={[
                            { required: true, whitespace: true, message: t('backoffice.validation.fieldRequired') },
                            { max: 30, message: t('backoffice.validation.fieldInvalid') },
                            { min: 3, message: t('backoffice.validation.fieldInvalid') },
                        ]}
                        validateFirst
                    >
                        <Input
                            placeholder={`${t('backoffice.common.enter')} ${t('backoffice.campaigns.name')}`}
                        />
                    </Form.Item>
                </Col>
                <Col span={24} >
                    <Form.Item
                        name={FIELD_NAMES.TRAFFIC_SOURCES}
                        label={t('backoffice.campaigns.trafficSource')}
                        className='rt--form-item-without-margin'
                    >
                        <Select
                            options={trafficSources.map(source => ({
                                value: source.longId,
                                text: source.name
                            }))}
                            placeholder={`${t('backoffice.common.select')} ${t('backoffice.campaigns.trafficSource')}`}
                            loading={false}
                            isMultiple={true}
                            getPopupContainer={() => document.getElementsByClassName("rt--portal-layout")[0]}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}

/** MediaSaveForm propTypes
    * PropTypes
*/
MediaSaveForm.propTypes = {
    formInstance: PropTypes.object,
    formInitialValues: PropTypes.object,
    trafficSources: PropTypes.arrayOf(autoSuggestionType),
    onValuesChange: PropTypes.func
}

export default MediaSaveForm;